import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Link } from "react-router-dom";
import Loginslider from "./Loginslider";
import OtpInput from "react-otp-input";
import {
  postLoginOTP,
  postSendOTP,
  SaveDevice,
} from "../Service/Auth-Services";
import OtpTimer from "otp-timer";
import { useHistory } from "react-router-dom";
import { useDataContext } from "../../../Services/Context-Api/Context";
import LoginLoader from "../../../Shared/Sidebar/LoginLoader";
import { TostMsg } from "../../../App";
import {
  GetMasterSystemAlert,
  menuDynamicFunctionality,
  NotificationCount,
} from "../../../Services/Global-Services/GlobalServices";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { triggerButterflyEffect } from "./ButterflyEffect";

function Otp() {
  const { apiData } = useDataContext();
  const [errorMessage, setErrorMessage] = useState(false ?? "");
  const [browserInfo, setBrowserInfo] = useState({ name: "", version: "" });
  const [loader, setLoader] = useState(false);
  const [otp, setOtp] = useState("");
  const [oTP_Validation_Resend_Message, setOTP_Validation_Resend_Message] =
    useState("");
  const [oTP_Validation_Message, setOTP_Validation_Message] = useState("");
  const [OTP_Validation_Header, setOTP_Validation_Header] = useState("");
  const history = useHistory();
  const toster = useContext(TostMsg);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");

  useEffect(() => {
    GetMasterSystemAlertList("OTP_Validation_Resend_Message", 3);
    GetMasterSystemAlertList("OTP_Validation_Message", 4);
    GetMasterSystemAlertList("OTP_Validation_Header", 5);

    const userAgent = navigator.userAgent;
    let name = "Unknown";
    let version = "Unknown";
    if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
      name = "Chrome";
      version = userAgent.match(/Chrome\/([\d.]+)/)?.[1] || "Unknown";
    } else if (userAgent.includes("Firefox")) {
      name = "Firefox";
      version = userAgent.match(/Firefox\/([\d.]+)/)?.[1] || "Unknown";
    } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
      name = "Safari";
      version = userAgent.match(/Version\/([\d.]+)/)?.[1] || "Unknown";
    } else if (userAgent.includes("Edg")) {
      name = "Edge";
      version = userAgent.match(/Edg\/([\d.]+)/)?.[1] || "Unknown";
    } else if (userAgent.includes("MSIE") || userAgent.includes("Trident")) {
      name = "Internet Explorer";
      version = userAgent.match(/(?:MSIE |rv:)([\d.]+)/)?.[1] || "Unknown";
    }
    setBrowserInfo({ name, version });
    if (!apiData) {
      history.push("/");
    }
    if (otp) {
      setErrorMessage(false);
    } else {
      setErrorMessage(true);
    }
  }, [otp]);

  async function Submit() {
    const localDate = new Date();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (otp.length == 5) {
      setLoader(true);
      let data = {
        username: apiData?.customer?.UserName,
        password: String(otp),
        SignUpFlow: true,
        CountryCode: "+91",
        TimeZone: timeZone,
      };
      try {
        let LoginByOTP = await postLoginOTP(data);
        let currentTime = new Date();
        LoginByOTP.Data.Authentication.expires_in = new Date(
          currentTime.setMinutes(
            currentTime.getMinutes() +
            LoginByOTP.Data.Authentication.expires_in / 60
          )
        );
        localStorage.setItem(
          "Authentication",
          JSON.stringify(LoginByOTP?.Data?.Authentication)
        );
        localStorage.setItem(
          "Permissions",
          JSON.stringify(LoginByOTP?.Data?.Permissions)
        );
        localStorage.setItem("Roles", JSON.stringify(LoginByOTP?.Data?.Roles));
        localStorage.setItem("User", JSON.stringify(LoginByOTP?.Data?.User));
        if (Date.now() <= new Date(2026, 10, 13, 23, 59, 59, 999).getTime()) {
          localStorage.setItem("showDiwaliCelebrationOnDashboard", "true");
        }
        localStorage.setItem("LanguageKey", JSON.stringify("English"));
        localStorage.setItem(
          "AppVersion",
          JSON.stringify(
            LoginByOTP?.Data?.User?.AppVersions?.find((el) => el?.Type == "Mobile")
          )
        );
        window.dispatchEvent(new Event('authStateChanged'));
        MenuDynamicFunctionality(LoginByOTP?.Data);
        postSaveDevice(LoginByOTP?.Data?.User);
        GetMasterSystemAfterLoginAlertList();
      } catch (err) {
        setLoader(false);
        setOtp(" ");
        setTimeout(() => {
          GetMasterSystemAlertList("Invalid_OTP", 1);
        }, 100);
      }
    } else {
      GetMasterSystemAlertList("OTP_Mandatory", 2);
    }
  }

  async function MenuDynamicFunctionality(userDetails) {
    var params = {
      OrgId: userDetails?.User?.OrgId,
      loggedInEmpId: userDetails?.User?.EmpId,
      WebOrMobile: 1,
    };
    try {
      const data = await menuDynamicFunctionality(params);
      localStorage.setItem("DynamicMenuJson", JSON.stringify(data.Data));
      notificationCount(userDetails);
    } catch (error) {
      toster.current.error(ERROR_LIST?.DynamicMenu);
    }
  }

  async function notificationCount(userDetails) {
    var params = {
      EmpId: userDetails?.User?.EmpId,
    };
    try {
      const data = await NotificationCount(params);
      setLoader(false);
      let count = 0
      if (data?.Data[0]?.UnreadNotifications) {
        count = data?.Data[0]?.UnreadNotifications;
      } else {
        count = 0;
      }
      localStorage.setItem(
        "NotificationCount",
        JSON.stringify(count)
      );
      history.push("/Dashboard");
    } catch (error) {
      toster.current.error(ERROR_LIST?.NotificationError);
    }
  }

  const ResendOTP = async () => {
    setErrorMessage(null);
    let data = {
      SignupFlow: false,
      UserName: apiData?.customer?.UserName,
    };
    let ResendOtp = await postSendOTP(data);
    if (ResendOtp.StatusCode == 2000) {
      GetMasterSystemAlertList("OTP_send_successfully", 0);
    } else {
      GetMasterSystemAlertList("Invalid_OTP", 1);
      return false;
    }
  };
  const { updateApiData } = useDataContext();
  const ChangeLoginData = async () => {
    await updateApiData(apiData?.customer?.UserName);
    history.push("/");
  };

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setErrorMessage(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setErrorMessage(msg?.Desc);
      } else if (msg?.Name == message && type == 3) {
        setOTP_Validation_Resend_Message(msg?.Desc);
      } else if (msg?.Name == message && type == 4) {
        setOTP_Validation_Message(msg?.Desc);
      } else if (msg?.Name == message && type == 5) {
        setOTP_Validation_Header(msg?.Desc);
      }
    });
  }, []);

  const GetMasterSystemAfterLoginAlertList = useCallback(async () => {
    const body = {
      Name: "",
    };
    try {
      let MasterSystemAlert = await GetMasterSystemAlert(body);
      localStorage?.setItem(
        "SystemAlerts",
        JSON?.stringify(MasterSystemAlert?.Data)
      );
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setLoader(false);
    }
  }, []);

  async function postSaveDevice(userDetails) {
    const now = new Date();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let appVersion = userDetails?.AppVersions?.find(
      (el) => el?.Type == "Web"
    )?.NewVersion;
    var params = {
      EmpId: userDetails?.EmpId,
      Device: browserInfo?.name,
      Desc: browserInfo?.version,
      AppVersion: String(appVersion),
      TimeZone: timeZone,
    };
    try {
      await SaveDevice(params);
    } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
      setLoader(false)
    }
  }
  return (
    <>
      <section className="fxt-template-animation fxt-template-layout29 loaded">
        <div className="login-org-logo-area">
          <div className="container">
            <a className="fxt-logo">
              <img
                src="images/login/logo.png"
                alt="Logo"
                className="logo-login"
              />
            </a>
          </div>
        </div>
        <img src="images/login/right.png" className="leftpic" />
        <img src="  images/login/left.png" className="rightpic" />
        <div className="login-org-area">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-7">
                <div className="fxt-content otp-screen-area">
                  <div className="fxt-form">
                    <div className="fxt-transformY-50 fxt-transition-delay-1">
                      <h2>{OTP_Validation_Header}</h2>
                      <div className="otp-company-name">
                        <h2>{apiData?.customer?.OrganizationName}</h2>
                      </div>
                    </div>
                    <div className="fxt-transformY-50 fxt-transition-delay-2">
                      <div
                        className="formdivv mb-3"
                        onClick={ChangeLoginData}
                        style={{ cursor: "pointer" }}
                      >
                        <p className="mb-1"> {oTP_Validation_Message}</p>
                        <p className="codesend">
                          <Link to="/">
                            {apiData?.customer?.UserName}
                            <i className="fa fa-pencil p-2"></i>{" "}
                          </Link>
                        </p>
                      </div>
                    </div>
                    <form className="otpdiv">
                      <OtpInput
                        className="otp"
                        value={otp}
                        onChange={(val) => setOtp(val.replace(/\D/g, ""))}
                        numInputs={5}
                        shouldAutoFocus={true}
                        isInputNum={true}
                        renderSeparator={<span> </span>}
                        renderInput={(inputProps, index) => (
                          <input
                            {...inputProps}
                            key={index}
                            onKeyDown={(e) => {
                              inputProps.onKeyDown?.(e);
                              if (e.key === "Enter") {
                                Submit();
                              }
                            }}
                          />
                        )}
                      />

                      {errorMessage && (
                        <div className="invalid-feedback">{errorMessage}</div>
                      )}
                      <div className="form-group mt-2 time-otp-msg">
                        <OtpTimer
                          seconds={30}
                          text={oTP_Validation_Resend_Message}
                          ButtonText="Resend OTP"
                          resend={ResendOTP}
                          textColor={"#000000"}
                          buttonColor={"#ff4500"}
                          background={"#fff"}
                        />
                        <div className="fxt-transformY-50 fxt-transition-delay-6 ">
                          <div className="fxt-content-between">
                            <button
                              type="button"
                              onClick={(e) => {
                                triggerButterflyEffect(e);
                                Submit(e);
                              }}
                              className="fxt-btn-fill"
                            >
                              {loader ? <LoginLoader /> : ""}Verify
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                    <div className="login-by-passcode-btn-area">
                      <Link to="LoginByPassword" className="pass-login me-2">
                        Login Using Password
                      </Link>
                      <div className="back-login-btn text-end">
                        <Link to="/" className="btnlogin-bx btn">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-arrow-left"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                            />
                          </svg>{" "}
                          Back
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="vegas-container col-lg-6 col-md-5">
                <div className="">
                  <img src="/images/login/signup.svg" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default Otp;
